<template>
  <commonSelect
    :value="value"
    @input="v=>$emit('input',v)"
    placeholder="请选择申请类型"
    :clearable="clearable"
    idKey="ApplyTypeId"
    labelKey="ApplyTypeName"
    :get-data-func="getDataFunc"
  />
</template>
<script>
import api from "@/api/ba/applyType";
import commonSelect from "@/components/common/select";
export default {
  props: {
    value: {},
    clearable: {
      type: Boolean,
      default: true,
    },
  },
  components: { commonSelect },
  data() {
    return { api };
  },
  methods: {
    getDataFunc() {
      return new Promise((resolve, reject) => {
        this.api.list({ Status: 1 }).then((res) => {
          // console.log(res.Data);
          resolve({ Data: res.Data });
        });
      });
    },
  },
};
</script>

